var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "Cross14_svg__cross14SVG",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.272.273a.93.93 0 0 1 1.316 0l4.923 4.94 4.923-4.94a.93.93 0 0 1 1.315 0 .936.936 0 0 1 0 1.32l-4.923 4.94 4.923 4.941a.936.936 0 0 1 0 1.32.93.93 0 0 1-1.315 0L6.51 7.854l-4.923 4.94a.93.93 0 0 1-1.316 0 .936.936 0 0 1 0-1.32l4.923-4.94-4.923-4.94a.936.936 0 0 1 0-1.32",
  clipRule: "evenodd"
})));
export default SvgCross14;